import { Component, OnInit } from '@angular/core';
import { HomePageService } from 'src/app/homepage/homepage.service';
import Swal from 'sweetalert2';
import { AdminComponent } from '../admin.component';
import { AdminService } from '../admin.service';
import { AdminPanelService } from './admin-panel.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.css']
})
export class AdminPanelComponent implements OnInit {
  oldPassword: string = '';
  newPassword: string = '';
  confirmPassword: string = '';
  incorrectOldPasswordError = false;
  confirmPasswordError = false;
  passwordChangedAlert = false;

  termsAndConditions: string = '';
  privacyPolicy: string = '';
  cancellationPolicy: string = '';
  termsAndPrivacyDataId: string = '';
  adminId: string = '';
  adminPassword: string = '';

  constructor(
    private adminPanelService: AdminPanelService,
    private homepageService: HomePageService,
    private adminService: AdminService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getTermsAndPrivacyData();
    this.adminPanelService.getAdminData().subscribe((data: any) => {
      this.adminId = data.success.adminData._id;
      this.adminPassword = data.success.adminData.password;
    });
  }

  onChangePassword() {
    this.incorrectOldPasswordError = false;
    this.confirmPasswordError = false;
    this.passwordChangedAlert = false;

    if (this.oldPassword !== this.adminPassword) {
      this.incorrectOldPasswordError = true;
    } else if (this.newPassword !== this.confirmPassword) {
      this.confirmPasswordError = true;
    } else {
      this.adminService.changePassword({
        Id: this.adminId,
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        confirmNewPassword: this.confirmPassword
      }).subscribe(() => {
        this.passwordChangedAlert = true;
        this.oldPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
      })
    }
  }

  getTermsAndPrivacyData() {
    this.homepageService.termConditionAndPrivacyPolicy().subscribe((data: any) => {
      // console.log(data);
      this.termsAndConditions = data.termAndPrivacyData.termCondition;
      this.privacyPolicy = data.termAndPrivacyData.privacyPolicy;
      this.cancellationPolicy = data.termAndPrivacyData.cancellationPolicy;
      this.termsAndPrivacyDataId = data.termAndPrivacyData._id;
    });
  }

  onUpdate() {
    // console.log(this.privacyPolicy, this.termsAndConditions, this.cancellationPolicy);
    this.adminPanelService.termConditionAndPrivacyPolicyEdit({
      Id: this.termsAndPrivacyDataId,
      privacyPolicy: this.privacyPolicy,
      termCondition: this.termsAndConditions,
      cancellationPolicy: this.cancellationPolicy
    }).subscribe(() => {
      Swal.fire('Content Updated Successfully!');
      this.getTermsAndPrivacyData();
    });
  }

  onLogout() {
    localStorage.removeItem('token');
    this.router.navigate(['/']);
  }

}
